import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchCustomerDocuments } from 'src/api/customer/documents';
import {
    FETCH_CUSTOMER_DOCUMENTS,
    requestCustomerDocuments,
    requestCustomerDocumentsFailure,
    requestCustomerDocumentsSuccess,
} from './actions';

/* Customer Documents */
function* fetchCustomerDocumentsSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerDocuments());

    const { error, response } = yield call(fetchCustomerDocuments);

    if (error) yield put(requestCustomerDocumentsFailure(error));
    else yield put(requestCustomerDocumentsSuccess(response));
}

export function* generateFetchCustomerDocumentsWatcher() {
    yield takeLatest(FETCH_CUSTOMER_DOCUMENTS, fetchCustomerDocumentsSaga);
}
